import React from "react"
import { BLOCKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import { Title, Indent } from "src/uikit"
import Button from "src/newUikit/Button"
import { getModalClickHandler } from "src/components/ModalsContainer/events"

import CheckIcon from "./assets/check-icon.svg"
import * as S from "./styled"

const options = {
  renderNode: {
    // eslint-disable-next-line react/display-name
    [BLOCKS.UL_LIST]: (node, children) => <S.List>{children}</S.List>,
    // eslint-disable-next-line react/display-name
    [BLOCKS.LIST_ITEM]: (node, children) => (
      <S.ListItem>
        <CheckIcon /> <span>{children}</span>
      </S.ListItem>
    ),
  },
}

const KeyPoints = ({
  title,
  json,
  btnName,
  btnUrl,
  btnModalType,
  btnModalTitle,
}) => {
  const handleClick = getModalClickHandler(btnModalType, {
    title: btnModalTitle,
  })

  return (
    <S.Container>
      <Indent lg={184} md={173} sm={103} />
      <div className="inner">
        <Title>{title}</Title>
        <Indent lg={40} md={40} sm={24} />
        {documentToReactComponents(json, options)}
        <Indent lg={44} md={20} sm={16} />
        {btnModalType && <Button onClick={handleClick}>{btnName}</Button>}
        {btnUrl && <Button url={btnUrl}>{btnName}</Button>}
      </div>
      <Indent lg={120} md={80} sm={64} />
    </S.Container>
  )
}

export default KeyPoints
